import React from 'react';

import { useState } from 'react';

import download from '../../assets/img/ico/download.svg';

export default function YearlySalaryTable({ data, year }) {

    const monthNames = [
        "January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
    ];

    const d = [];

    for (let i = 0; i < data.length; i++) {
        const item = data[i];
        if (item.year === year) {
            d.push(item);
        }
    }

    return (
        <div className="salary-table">
            <div>{year}</div>
            {
                d.map((item, index) => (
                    <div className="salary-table-row" key={index}>
                        <p>
                            {item.company} - {monthNames[item.month] + ' ' + item.year}
                        </p>
                        <img src={download} alt="download" />
                    </div>
                ))
            }
        </div>
    );
}